module.exports = __webpack_public_path__ + "static/img/Cover_Line_Pansook.5d22c13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cover_Line_Pansook.jpg
// module id = LStK
// module chunks = 2